import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Methods from './Methods';
import Form from './Form';
import styles from './modal.module.scss';

class Modal extends Component {
  state = {
    isFormShowing: false,
  };

  showForm = e => {
    if (e) {
      e.preventDefault();
    }

    this.setState({isFormShowing: true});
  };

  // Keeps clicks inside the dialog from closing it via the backdrop
  stopPropagation = e => {
    e.stopPropagation();
  };

  render() {
    const {close} = this.props;
    const {isFormShowing} = this.state;

    return (
      <div className={styles.Modal} onClick={close} role="presentation">
        <div
          aria-label="Contact TeamGantt support"
          aria-modal="true"
          className={styles.Modal__body}
          onClick={this.stopPropagation}
          role="dialog"
        >
          <button
            aria-label="Close"
            className={styles.Modal__close}
            onClick={close}
            type="button"
          >
            &times;
          </button>
          {!isFormShowing ? (
            <div>
              <div className={styles.Modal__heading}>
                <p className={styles.Modal__eyebrow}>Contact us</p>
                <h3 className={styles.Modal__title}>How can we assist you?</h3>
                <p className={styles.Modal__summary}>
                  We’re real people who are always happy to help.
                </p>
              </div>
              <Methods showForm={this.showForm} />
            </div>
          ) : (
            <Form />
          )}
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/contact/Modal.js